import React from "react";

import { config } from "../../../config/index";

import placeholderImage from "../../../assets/images/placeholder.jpg";

const { SERVER_URL } = config;

const profileInfo = ({ user }) => (
  <div className="container py-3 d-flex align-items-center">
    <img
      className="img-responsive mr-3 rounded-circle border"
      style={{ height: "100px", width: "100px" }}
      src={user.image ? `${SERVER_URL}/${user.image}` : placeholderImage}
      alt="user-profile"
    />
    <span>
      <h5>{user.full_name}</h5>
      <p>(#{user.employee_no})</p>
    </span>
  </div>
);

export default profileInfo;
